import { Button, Divider, Form, Input, Modal, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import { DownloadOutlined } from "@ant-design/icons";

import EmptyPlaceholder from "common/components/emptyPlaceholder/emptyPlaceholder";
import { convertIntoDashUSFormat } from "utilities/dateUtility";

import { useSelector } from "react-redux";
import {
  isPermissionPresent,
  noTrailingSpaceAllowedRule,
} from "utilities/generalUtility";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import Client from "redux/models/client";
import DragUpload from "common/components/uploadComponent/dragger";
import { DeleteAttachmentButton } from "./deleteAttachmentButton";

const { Title } = Typography;

export default function CandidateAttachment({
  styles,
  candidateActivity,
  onCountChange,
}) {
  const [form] = Form.useForm();
  const uploadRef = useRef();

  const [attachments, setAttachments] = useState([]);
  const [file, setFile] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const userSlice = useSelector(selectUser);
  const [isLoading, setIsLoading] = useState(false);

  const handleOk = () => {
    form.submit();
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const afterModalClose = () => {
    setFile(null);
    form.resetFields();
    uploadRef.current?.reset();
  };

  const getAttachments = async () => {
    const body = {
      entityId: candidateActivity.id,
      type: K.AttachmentType.Candidate,
    };

    try {
      const res = await Client.getAttachment(body, {
        showError: false,
        skipForbiddenRedirect: true,
      });
      setAttachments([...res]);
      onCountChange?.(res.length);
    } catch (error) {
      setAttachments([]);
      onCountChange?.(0);
      console.log(error);
    }
  };
  useEffect(() => {
    getAttachments();
  }, [candidateActivity]);

  const onFileChange = (selectedFile, error) => {
    setFile(selectedFile);
    form.setFields([{ name: "document", errors: error ? [error] : [] }]);
  };
  const show = () => {
    setIsModalVisible(true);
  };

  const onFinish = async (values) => {
    try {
      setIsLoading(true);

      const res = await Client.uploadAttachement(
        file,
        K.S3Folders.CandidateAttachments + candidateActivity.id,
      );

      const payload = {
        entityId: candidateActivity.id, // Candidate Id
        type: K.AttachmentType.Candidate,
        title: values.title,
        attachment: res.filepath,
      };

      await Client.createAttachment(payload);
      getAttachments();
      setIsLoading(false);
      setIsModalVisible(false);
      form.resetFields();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadFile = async (url) => {
    const downloadUrl = await Client.getPreSignedUrl(url);
    window.open(downloadUrl);
  };

  return (
    <>
      <div className={`${styles.issueCredits} issue-credit-head`}>
        <div className="issue-btn-wrap">
          {isPermissionPresent(K.Permissions.AddAttchment, userSlice.roles) && (
            <Button
              type="primary"
              className={styles.resubmitBtn}
              onClick={show}
              disabled={candidateActivity.isConsiderable === 0}
            >
              Add Document
            </Button>
          )}
        </div>
      </div>
      <Scrollbars style={{ height: 400 }}>
        {attachments.length ? (
          attachments.map((item, i) => (
            <div key={i} className={styles.invoiceWrap}>
              <div className={styles.invoiceDetail}>
                <div className={styles.invoiceDate}>
                  <Title level={5}>
                    Title: <span>{item.title}</span>
                  </Title>
                  <div style={{ justifyContent: "end" }}>
                    <Button
                      className={styles.reloadBtn}
                      type="link"
                      onClick={() => {
                        downloadFile(item.attachment);
                      }}
                    >
                      <DownloadOutlined />
                    </Button>
                    {isPermissionPresent(
                      K.Permissions.DeleteAttachment,
                      userSlice.roles,
                    ) && (
                      <DeleteAttachmentButton
                        item={item}
                        onSuccess={getAttachments}
                      />
                    )}
                  </div>
                </div>
                <Divider className={styles.invoiceDivider} />
                <div className={styles.invoiceDate}>
                  <Title level={5}>
                    Uploaded Date:
                    <span>
                      {" "}
                      {convertIntoDashUSFormat(item.createdAt, false)}
                    </span>
                  </Title>
                  <Title level={5}>
                    Uploaded By: <span>{item.userName}</span>
                  </Title>
                </div>
              </div>
            </div>
          ))
        ) : (
          <EmptyPlaceholder />
        )}
      </Scrollbars>

      <Modal
        forceRender
        className="s2-theme-style"
        title="Add Documents"
        open={isModalVisible}
        centered
        closeIcon={<i className="icon-closeable" />}
        okText="Add"
        wrapClassName="vertical-center-modal"
        onOk={handleOk}
        okButtonProps={{ loading: isLoading }}
        onCancel={handleCancel}
        afterClose={afterModalClose}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={null}
        >
          <Form.Item
            label="Title"
            name="title"
            rules={[
              { required: true, message: "Title is required." },
              noTrailingSpaceAllowedRule(),
            ]}
          >
            <Input placeholder="Enter Title" />
          </Form.Item>
          <Form.Item
            label="Document"
            name="document"
            rules={[
              {
                required: true,
                validator: (_, obj) => {
                  if (file) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Please upload documents!");
                },
              },
            ]}
          >
            <DragUpload
              ref={uploadRef}
              onFileChange={onFileChange}
              allowedTypes={K.FileUpload.Groups.DOCUMENTS_AND_IMAGES}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
